export default "__VITE_ASSET__iAbv1305__"